import { replaceQueryParams } from 'shared/utils/replace-query-params';

export type FetchBlobResult = {
  blob?: Blob;
  filename: string;
  filesize: number;
  error?: string;
  errors?: string[];
};

export type FetchBlobOptions = {
  defaultFilename: string;
  fallbackErrorMessage?: string;
};

export async function fetchBlob(
  url: string,
  { defaultFilename, fallbackErrorMessage = 'Не удалось скачать файл' }: FetchBlobOptions,
): Promise<FetchBlobResult> {
  const token = localStorage.getItem('token');

  if (!token) {
    return {
      filename: defaultFilename,
      filesize: 0,
      error: 'Токен авторизации отсутствует',
    };
  }

  const neededUrl = new URL(url);
  neededUrl.search = replaceQueryParams(neededUrl.search);

  try {
    const response = await fetch(neededUrl.toString(), {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${token}`,
      }),
    });

    if (!response.ok) {
      const result = await response.json();
      const validationErrors = parseValidationErrors(result.data);

      return {
        filename: defaultFilename,
        filesize: 0,
        error: result.message || fallbackErrorMessage,
        ...(validationErrors.length > 0 ? { errors: validationErrors } : {}),
      };
    }

    const filename =
      getFilenameFromContentDisposition(
        response.headers.get('Content-Disposition'),
      ) || defaultFilename;

    return {
      blob: await response.blob(),
      filename,
      filesize: parseInt(response.headers.get('content-length') || '0', 10),
    };
  } catch {
    return {
      filename: defaultFilename,
      filesize: 0,
      error: fallbackErrorMessage,
    };
  }
}

export function getFilenameFromContentDisposition(
  header: string | null,
): string | null {
  if (!header) {
    return null;
  }

  const filenameRegex = /filename\*?=(?:UTF-8''|["']?)([^"';\n\r]+)/i;
  const match = header.match(filenameRegex);

  if (match?.[1]) {
    try {
      return decodeURIComponent(match[1].replace(/\+/g, ' '));
    } catch {
      return match[1];
    }
  }

  return null;
}

function parseValidationErrors(data?: {
  errors?: Array<{ constraints?: Record<string, string> }>;
}) {
  const errors: string[] = [];

  if (!data?.errors) {
    return errors;
  }

  data.errors.forEach(({ constraints }) => {
    if (constraints) {
      for (const [key, value] of Object.entries(constraints)) {
        errors.push(`${key}: ${value}`);
      }
    }
  });

  return errors;
}
